var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596266",
    d: "M7,7 L7,4 L6.5,4 C5.67157288,4 5,4.67157288 5,5.5 C5,6.32842712 5.67157288,7 6.5,7 L7,7 Z M9,4 L9,7 L9.75,7 C11.5449254,7 13,8.56700338 13,10.5 C13,12.4329966 11.5449254,14 9.75,14 L9,14 L9,16 L7,16 L7,14 L6.25,14 C4.45507456,14 3,12.4329966 3,10.5 L5,10.5 C5,11.3284271 5.67157288,12 6.5,12 L7,12 L7,9 L6.25,9 C4.45507456,9 3,7.43299662 3,5.5 C3,3.56700338 4.45507456,2 6.25,2 L7,2 L7,0 L9,0 L9,2 L9.75,2 C11.5449254,2 13,3.56700338 13,5.5 L11,5.5 C11,4.67157288 10.3284271,4 9.5,4 L9,4 Z M9,9 L9,12 L9.5,12 C10.3284271,12 11,11.3284271 11,10.5 C11,9.67157288 10.3284271,9 9.5,9 L9,9 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.e248839c.svg";
export { ForwardRef as ReactComponent };